import { call, takeLatest } from "redux-saga/effects";
import * as droperApis from "../apis/droperApis"
import { CREATE_DROPER, EDIT_DROPER, ENABLE_DISABLE_DROPER, LIST_DROPER, RESET_PASSWORD, RESET_PASSWORD_DROPER, UPLOAD_DROPER_IMAGE, VIEW_DROPER } from "../actions/types";


export function* createDroperWorker(action) {
    try {
        const res = yield call(droperApis.createDroperApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* editDroperWorker(action) {
    try {
        const res = yield call(droperApis.editDroperApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


export function* listDroperWorker(action) {
    try {
        const res = yield call(droperApis.listDroperApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* viewDroperWorker(action) {
    try {
        const res = yield call(droperApis.viewDroperApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* enableDisableDroperWorker(action) {
    try {
        const res = yield call(droperApis.enableDisableDroperApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* resetPasswordDroperWorker(action) {
    try {
        const res = yield call(droperApis.resetPasswordDroperApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* uploadDroperImageWorker(action) {
    try {
        const file = new FormData();
        file.append("file", action.file);
        const res = yield call(droperApis.uploadDroperImageApi, file);

        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}


/**Watcher Func */
export function* createDroperWatcher() {
    yield takeLatest(CREATE_DROPER, createDroperWorker);
}
export function* editDroperWatcher() {
    yield takeLatest(EDIT_DROPER, editDroperWorker);
}
export function* listDroperWatcher() {
    yield takeLatest(LIST_DROPER, listDroperWorker);
}
export function* viewDroperWatcher() {
    yield takeLatest(VIEW_DROPER, viewDroperWorker);
}
export function* enableDisableDroperWatcher() {
    yield takeLatest(ENABLE_DISABLE_DROPER, enableDisableDroperWorker);
}
export function* resetPasswordDroperWatcher() {
    yield takeLatest(RESET_PASSWORD_DROPER, resetPasswordDroperWorker);
}
export function* uploadDroperImageWatcher() {
    yield takeLatest(UPLOAD_DROPER_IMAGE, uploadDroperImageWorker);
}